import { ChildAlertProps } from '../BaseAlert.component';
import WarningAlertComponent from '../WarningAlert.component';
import React from 'react';
import { useTranslation } from 'react-i18next';

const AttachmentRemoveAlertComponent = ({ handleConfirm }: ChildAlertProps) => {
  const { t } = useTranslation();
  return (
    <WarningAlertComponent onClose={handleConfirm}>
      {t('Attachment will be removed')}.
      <br />
      {t('Continue')}?
    </WarningAlertComponent>
  );
};

export default AttachmentRemoveAlertComponent;
